import { type MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { emptyCellOneLevel } from '@/shared';
import type { CobranzasRow } from '../utils';

export const useColumnsCobranzas = () => {
  const columnsCobranzas = useMemo<MRT_ColumnDef<CobranzasRow>[]>(
    () => [
      {
        accessorKey: 'idContrato',
        header: 'CONTRATO',
        size: 120,
        Cell: ({ row }) => emptyCellOneLevel(row, 'idContrato'),
      },
      {
        accessorKey: 'identificacion',
        header: 'IDENTIFICACIÓN',
        size: 150,
        Cell: ({ row }) => emptyCellOneLevel(row, 'identificacion'),
      },
      {
        accessorKey: 'nombreCliente',
        header: 'CLIENTE',
        size: 280,
        Cell: ({ row }) => emptyCellOneLevel(row, 'nombreCliente'),
      },
      {
        accessorKey: 'sector',
        header: 'SECTOR',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'sector'),
      },
      {
        accessorKey: 'valorPlan',
        header: 'VALOR PLAN',
        size: 120,
        Cell: ({ row }) => emptyCellOneLevel(row, 'valorPlan'),
      },
      {
        accessorKey: 'deuda',
        header: 'DEUDA',
        size: 110,
        Cell: ({ row }) => emptyCellOneLevel(row, 'deuda'),
      },
      {
        accessorKey: 'mes',
        header: 'MES',
        size: 100,
        Cell: ({ row }) => emptyCellOneLevel(row, 'mes'),
      },
      {
        accessorKey: 'correo',
        header: 'CORREO',
        size: 240,
        Cell: ({ row }) => emptyCellOneLevel(row, 'correo'),
      },
      {
        accessorKey: 'telefonos',
        header: 'TELÉFONOS',
        size: 260,
        Cell: ({ row }) => emptyCellOneLevel(row, 'telefonos'),
      },
    ],
    []
  );

  return {
    columnsCobranzas,
  };
};
